import styled from "styled-components";

export const Container = styled.div``;

export const AddressContainer = styled.div<{hasFrom?:boolean,type:string}>`
    display: flex;
    flex-direction: column;

    row-gap: 0px;

    max-height: 70px;

    ${({type}) => type!=='unit' ? 'margin-bottom: 0px;' : 'margin-bottom: 16px;'}

`;

export const ValueContainer = styled.div`
    display: flex;
    flex-direction: column;

    row-gap: 8px;

    max-height:47px;
`;